import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { db } from '../firebase';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import ChatListItem from '../components/ChatListItem';
import { MdOutlineCameraAlt } from "react-icons/md";
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FaSearch } from 'react-icons/fa';
import { toast } from 'react-toastify';

export default function Messages() {
  const auth = getAuth();
  const navigate = useNavigate();
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!auth.currentUser?.uid) return;

    const q = query(
      collection(db, 'chats'),
      where('participants', 'array-contains', auth.currentUser.uid),
      orderBy('lastMessageTimestamp', 'desc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const chatsData = [];
      snapshot.forEach((doc) => {
        chatsData.push({
          id: doc.id,
          ...doc.data()
        });
      });
      setChats(chatsData);
      setLoading(false);
    }, (error) => {
      console.error('Error fetching chats:', error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth.currentUser]);

  const handleNewChatClick = () => {
    toast.info('This feature is not yet available in your region!', {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  if (loading) {
    return (
      <div className="bg-black text-white h-screen flex items-center justify-center">
        <div className="animate-pulse">Loading conversations...</div>
      </div>
    );
  }

  return (
    <div className="bg-black text-white h-screen flex flex-col">
      {/* Header */}
      <div className="bg-gray-900 p-4 flex justify-between items-center border-b border-gray-800">
        <h1 className="text-xl font-bold">AweitChat</h1>
        <div className="flex space-x-4">
          <button className="text-white hover:text-blue-500">
            <MdOutlineCameraAlt size={24} />
          </button>
          <button className="text-white hover:text-blue-500">
            <BsThreeDotsVertical size={20} />
          </button>
        </div>
      </div>

      {/* Sticky Search Bar */}
      <div className="sticky top-0 z-10 bg-black bg-opacity-90 border-b border-gray-800 p-4">
        <div className="relative max-w-xl mx-auto">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FaSearch className="text-gray-500" />
          </div>
          <input
            type="text"
            placeholder="Ask Aweit AI or Search"
            className="w-full bg-gray-900 border border-gray-700 text-white pl-10 pr-4 py-2 rounded-full focus:outline-none focus:border-[#FF1493]"
            aria-label="Search users by username"
          />
        </div>
      </div>

      {/* Chat List */}
      <div className="flex-1 overflow-y-auto">
        {chats.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full p-4">
            <p className="text-gray-400 text-center">No conversations yet</p>
            <button 
              onClick={handleNewChatClick}
              className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-lg"
            >
              Start a new chat
            </button>
          </div>
        ) : (
          chats.map((chat) => (
            <ChatListItem 
              key={chat.id} 
              chat={chat} 
              currentUserId={auth.currentUser?.uid}
              onClick={() => navigate(`/chat/${chat.id}`)}
            />
          ))
        )}
      </div>
    </div>
  );
}